<title>{{ ndcHelpdeskFaqPage.htmlTitle }}</title>
<app-banner [banner]="ndcHelpdeskFaqPage.banner"></app-banner>
<div class="container faq-disruption-notifications">
  <a [href]="BackLinkURL"><i [ngClass]="BackLinkIcon"></i>{{ BackLinkTitle }}</a>
  <app-border-section [param]="param" [sections]="ndcHelpdeskFaqPage.sections"></app-border-section>
</div>
